import React, { useEffect, useState } from "react";

// Detects the user's reduced-motion preference.
export const usePrefersReducedMotion = () => {
  const [reduce, setReduce] = useState(false);
  useEffect(() => {
    const mq = window.matchMedia("(prefers-reduced-motion: reduce)");
    const on = () => setReduce(mq.matches);
    on();
    mq.addEventListener?.("change", on);
    return () => mq.removeEventListener?.("change", on);
  }, []);
  return reduce;
};

/**
 * Fixed, full-viewport ambient video background (light plexus/network).
 * Sits behind page content; a white veil keeps text fully readable.
 * Falls back to a static light gradient when reduced-motion is requested.
 */
const VideoBackground = ({ veil = 0.5 }) => {
  const reduce = usePrefersReducedMotion();
  return (
    <div className="video-bg" aria-hidden="true">
      {!reduce && (
        <video autoPlay muted loop playsInline preload="auto">
          <source src="/background_network.mp4" type="video/mp4" />
        </video>
      )}
      <div className="video-bg-veil" style={{ background: `rgba(255,255,255,${veil})` }} />
    </div>
  );
};

export default VideoBackground;
